import React from 'react';

import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import {DeereFetch} from '../../shared/fetch';
import {CountrySelect} from '../CountrySelect';
import {RoleSelect} from '../RoleSelect';
import {Dot} from '../Dot';
import {Name} from '../Name';
import styles from './index.css';

export class UsersCardItem extends React.Component {
    constructor(props) {
        super(props);
        const {user} = props;

        this.state = {
            loading: false,
            uid: user && user.id || '',
            role: user && user.role || 'VIEW',
            countries: user && user.countries.map(({id}) => id.countryCode) || []
        };
    }

    componentDidUpdate(_, prevState) {
        if (prevState.countries !== this.state.countries) {
            this.saveCountries();
        }

        if (prevState.role !== this.state.role) {
            this.saveRole();
        }
    }

    render() {
        return (
            <Grid alignItems="center" className={styles.root} container justifyContent="space-between"
                style={this.props.style}>
                <Grid alignItems="center" className={styles.name} container item xs>
                    {this.props.editUid ? (
                        <TextField
                            id={'racf-id' + this.state.uid}
                            margin="none"
                            onBlur={() => this.saveRole()}
                            onChange={({target}) => this.setState({uid: target.value})}
                            placeholder="RACF ID"
                            size="small"
                            value={this.state.uid}
                            variant="outlined"
                        />
                    ) : (
                        <Name {...this.props.user} includeID={true}/>
                    )}
                    {this.props.user && this.props.user.pending && (
                        <Dot color="#FFC107" style={{marginLeft: 10}}/>
                    )}
                </Grid>
                <Grid alignItems="center" container item justifyContent="flex-end" xs>
                    {this.props.user && (
                        <CountrySelect
                            countries={this.state.countries}
                            disabled={!this.props.user}
                            loading={this.props.loading}
                            onChange={(countries) => {
                                this.setState({countries});
                            }}
                        />
                    )}
                    <RoleSelect
                        loading={this.props.loading}
                        onChange={async (role) => {
                            this.setState({role});
                        }}
                        role={this.state.role}
                    />
                </Grid>
            </Grid>
        );
    }

    async deleteUser(id) {
        await DeereFetch(`/api/users/${id}`, {
            method: 'DELETE'
        });
    }

    async saveRole() {
        if (!this.props.user && (!this.state.uid || !this.state.role)) return;

        this.setState({
            loading: true
        });

        let updatedUser;
        try {
            if (this.props.user && this.props.user.id !== this.state.uid) {
                await this.deleteUser(this.props.user.id);
            }

            if (this.state.uid) {
                updatedUser = await DeereFetch(`/api/users/${this.state.uid}/role`, {
                    method: 'POST',
                    query: {
                        role: this.state.role
                    }
                });
            }

            if (this.props.clearAfterSave) {
                this.setState({
                    uid: '',
                    role: 'VIEW'
                });
            }
        } finally {
            this.setState({
                loading: false
            });
        }

        this.props.onChange(updatedUser);
    }

    async saveCountries() {
        if (!this.props.user) return;

        this.setState({
            loading: true
        });

        try {
            await DeereFetch(`/api/users/${this.props.user.id}/countries`, {
                method: 'POST',
                query: {
                    country: this.state.countries
                }
            });
        } finally {
            this.setState({
                loading: false
            });
        }
    }
}
